export {
  useInstitution,
  type UseInstitutionReturnType,
} from './useInstitution';
